"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFeDetails = exports.feDetailLabels = exports.approvalsFormConstants = exports.cashActionUpdate = exports.convertCashDeletionApprovalList = exports.cashDeletionApprovalList = exports.convertApprovalDetailsFromRes = exports.levelTwoVendorPendingList = exports.levelOneVendorPendingList = exports.levelTwoPendingList = exports.levelOnePendingList = void 0;
var react_hot_toast_1 = require("react-hot-toast");
var api_service_1 = require("../../../../api/api_service");
var array_helpers_1 = require("../../../../utils/array_helpers");
var lodash_1 = require("./../../../../utils/lodash");
var store_1 = require("../../../../store");
var profile_detaile_lable_1 = require("../../../../constants/profile_detaile_lable");
var levelOnePendingList = function (payLoad) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.LEVEL_ONE_PENDING_LIST,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: Object.keys(payLoad).length > 0 ? payLoad : undefined,
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data.data);
            }
            var erroMessage = response.data
                ? response.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.levelOnePendingList = levelOnePendingList;
var levelTwoPendingList = function (payLoad) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.LEVEL_TWO_PENDING_LIST,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: Object.keys(payLoad).length > 0 ? payLoad : undefined,
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data.data);
            }
            var erroMessage = response.data
                ? response.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.levelTwoPendingList = levelTwoPendingList;
var levelOneVendorPendingList = function (payLoad) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.VENDOR_LEVEL_ONE_PENDING_LIST,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: Object.keys(payLoad).length > 0 ? payLoad : undefined,
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data.data);
            }
            var erroMessage = response.data
                ? response.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.levelOneVendorPendingList = levelOneVendorPendingList;
var levelTwoVendorPendingList = function (payLoad) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.VENDOR_LEVEL_TWO_PENDING_LIST,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: Object.keys(payLoad).length > 0 ? payLoad : undefined,
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data.data);
            }
            var erroMessage = response.data
                ? response.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.levelTwoVendorPendingList = levelTwoVendorPendingList;
var convertApprovalDetailsFromRes = function (res) {
    var _a, _b, _c, _d, _e, _f, _g;
    var regionalManagers = store_1.store.getState().appConfigList.regional_managers;
    var zonalManagers = store_1.store.getState().appConfigList.zonal_managers;
    var billingModules = store_1.store.getState().appConfigList.billing_modules;
    var billingTypes = store_1.store.getState().appConfigList.billing_types;
    var regionalManager;
    var zonalManager;
    var zone;
    var updatedRegionalManager;
    var updatedZonalManager;
    var updatedZone;
    var updatedBillingModule;
    var updatedBillingType;
    if (((_a = res === null || res === void 0 ? void 0 : res.updated_profile) === null || _a === void 0 ? void 0 : _a.regional_manager_id) && regionalManagers.length) {
        updatedRegionalManager = regionalManagers.find(function (r) { return r.regional_manager_id === res.updated_profile.regional_manager_id; });
    }
    if (((_b = res === null || res === void 0 ? void 0 : res.updated_profile) === null || _b === void 0 ? void 0 : _b.zone_id) && regionalManagers.length) {
        updatedZone = regionalManagers.find(function (r) { return r.id === res.updated_profile.zone_id; });
    }
    if ((res === null || res === void 0 ? void 0 : res.regional_manager_id) && regionalManagers.length) {
        regionalManager = regionalManagers.find(function (r) { return r.regional_manager_id === res.regional_manager_id; });
    }
    if ((res === null || res === void 0 ? void 0 : res.zone_id) && regionalManagers.length) {
        zone = regionalManagers.find(function (r) { return r.id === res.zone_id; });
    }
    if ((res === null || res === void 0 ? void 0 : res.zone_id) && regionalManagers.length && zonalManagers.length) {
        var zoneObj_1 = regionalManagers.find(function (r) { return r.id === res.zone_id; });
        if (zoneObj_1) {
            zonalManager = zonalManagers.find(function (z) { return z.zone === zoneObj_1.zone; });
        }
    }
    if (((_c = res === null || res === void 0 ? void 0 : res.updated_profile) === null || _c === void 0 ? void 0 : _c.zone_id) && regionalManagers.length && zonalManagers.length) {
        var updatedZoneObj_1 = regionalManagers.find(function (r) { return r.id === res.updated_profile.zone_id; });
        if (updatedZoneObj_1) {
            updatedZonalManager = zonalManagers.find(function (z) { return z.zone === updatedZoneObj_1.zone; });
        }
    }
    if (res && res.updated_profile && res.updated_profile.billing_module && billingModules.length > 0) {
        updatedBillingModule = billingModules === null || billingModules === void 0 ? void 0 : billingModules.find(function (route) { return route.value === res.updated_profile.billing_module; });
    }
    if (res && res.updated_profile && res.updated_profile.billing_type && billingTypes.length > 0) {
        updatedBillingType = billingTypes === null || billingTypes === void 0 ? void 0 : billingTypes.find(function (route) { return route.value === res.updated_profile.billing_type; });
    }
    var emptyDetails = '--';
    var convertedRes = {};
    var personal_details = {
        firstName: res.first_name ? res.first_name : emptyDetails,
        lastName: res.last_name ? res.last_name : emptyDetails,
        dob: res.dob ? (0, array_helpers_1.normaldateFormatte)(res.dob) : emptyDetails,
        mobileNumber: res.mobile ? res.mobile : emptyDetails,
        email: res.email ? res.email : emptyDetails,
        gender: res.gender ? res.gender : emptyDetails,
        emergencyContactNo: res.emergency_mobile
            ? res.emergency_mobile
            : emptyDetails,
        uploadPhoto: res.avatar ? res.avatar : '',
        referenceContactName1: res.reference_name1
            ? res.reference_name1
            : emptyDetails,
        referenceMobileNumber1: res.reference_mobile1
            ? res.reference_mobile1
            : emptyDetails,
        referenceContactName2: res.reference_name2
            ? res.reference_name2
            : emptyDetails,
        referenceMobileNumber2: res.reference_mobile2
            ? res.reference_mobile2
            : emptyDetails,
    };
    var contactDetails = {
        addresslane1: res.addresses && res.addresses[0] ? res.addresses[0].lane1 : emptyDetails,
        addresslane2: res.addresses && res.addresses[0] ? res.addresses[0].lane2 : emptyDetails,
        landmark: res.addresses && res.addresses[0] ? res.addresses[0].landmark : emptyDetails,
        state: res.addresses && res.addresses[0]
            ? res.addresses[0].state_name
            : emptyDetails,
        city: res.addresses && res.addresses[0]
            ? res.addresses[0].city_name
            : emptyDetails,
        country: res.addresses && res.addresses[0]
            ? res.addresses[0].country_name
            : emptyDetails,
        pincode: res.addresses && res.addresses[0]
            ? (_d = res.addresses[0].pincode) === null || _d === void 0 ? void 0 : _d.toString()
            : emptyDetails,
        addressProofType: res.addresses && res.addresses[0]
            ? res.addresses[0].proof_of_doc_type
            : emptyDetails,
        proofOfAddress: res.addresses && res.addresses[0] ? res.addresses[0].proof_of_doc : '',
        permenentAddresslane1: res.addresses && res.addresses[1] ? res.addresses[1].lane1 : emptyDetails,
        permenentAddresslane2: res.addresses && res.addresses[1] ? res.addresses[1].lane1 : emptyDetails,
        permenentLandmark: res.addresses && res.addresses[1] ? res.addresses[1].landmark : emptyDetails,
        permenentState: res.addresses && res.addresses[1]
            ? res.addresses[1].state_name
            : emptyDetails,
        permenentCity: res.addresses && res.addresses[1]
            ? res.addresses[1].city_name
            : emptyDetails,
        permenentCountry: res.addresses && res.addresses[1]
            ? res.addresses[1].country_name
            : emptyDetails,
        permenentPincode: res.addresses && res.addresses[1]
            ? (_e = res.addresses[1].pincode) === null || _e === void 0 ? void 0 : _e.toString()
            : emptyDetails,
        permanentProofOfAddressType: res.addresses && res.addresses[1]
            ? res.addresses[1].proof_of_doc_type
            : emptyDetails,
        permenentProofOfAddress: res.addresses && res.addresses[1] ? res.addresses[1].proof_of_doc : '',
    };
    var bank_details = {
        AccountNumber: res.bank_account ? res.bank_account.toString() : emptyDetails,
        Bank_Branch: res.bank_branch ? res.bank_branch.toString() : emptyDetails,
        Bank_Name: res.bank_name ? res.bank_name.toString() : emptyDetails,
        IFSC_Code: res.bank_ifsc ? res.bank_ifsc.toString() : emptyDetails,
        UPI_ID: res.bank_upi_id ? res.bank_upi_id : emptyDetails,
        proofOfBankAccountDetails: res.bank_cheque_doc ? res.bank_cheque_doc : '',
    };
    var driving_licence_details = {
        vehicleType: res.vehicle_type ? res.vehicle_type : emptyDetails,
        drivingLicence: res.driving_licence ? res.driving_licence : emptyDetails,
        drivingLicenceExpirydate: res.driving_licence_expiry
            ? (0, array_helpers_1.normaldateFormatte)(res.driving_licence_expiry)
            : emptyDetails,
        insuranceExpirydate: res.insurance_expiry
            ? (0, array_helpers_1.normaldateFormatte)(res.insurance_expiry)
            : emptyDetails,
        insuranceNumber: res.insurance ? res.insurance : emptyDetails,
        uploadInsuranceDoc: res.insurance_photo ? res.insurance_photo : '',
        proofOfDrivingLicence: res.driving_licence_doc ? res.driving_licence_doc : '',
        rcNumber: res.rc_number ? res.rc_number : emptyDetails,
        rcExpirydate: res.rc_expiry ? res.rc_expiry : emptyDetails,
        pucNumber: res.puc_number ? res.puc_number : emptyDetails,
        pucExpirydate: res.puc_expiry ? res.puc_expiry : emptyDetails,
        proofOfRegistrationCertificate: res.rc_document ? res.rc_document : '',
        proofOfPUCCertificate: res.puc_document ? res.puc_document : '',
    };
    var employmentDetails = {
        employee_vendor_id: res.employee_id ? res.employee_id : emptyDetails,
        fe_Type: res.fe_type ? res.fe_type : emptyDetails,
        dateOfJoining: res.date_of_joining
            ? (0, array_helpers_1.normaldateFormatte)(res.date_of_joining)
            : emptyDetails,
        company: res.company ? res.company : emptyDetails,
        tenure: res.tenure ? res.tenure : emptyDetails,
        labCode: res.lab_code ? res.lab_code : emptyDetails,
        labName: res.centre_name ? res.centre_name : emptyDetails,
        HudId: res.hub_name ? res.hub_name : emptyDetails,
        regional_manager: (regionalManager === null || regionalManager === void 0 ? void 0 : regionalManager.label) ? regionalManager === null || regionalManager === void 0 ? void 0 : regionalManager.label : '',
        zonal_manager: (zonalManager === null || zonalManager === void 0 ? void 0 : zonalManager.zonal_manager) ? zonalManager === null || zonalManager === void 0 ? void 0 : zonalManager.zonal_manager : '',
        zone: (zone === null || zone === void 0 ? void 0 : zone.zone) ? zone === null || zone === void 0 ? void 0 : zone.zone : '',
        labState: res.centre_state ? res.centre_state : emptyDetails,
        labCity: res.centre_city ? res.centre_city : emptyDetails,
        fe_working_state: res.working_state ? res.working_state : emptyDetails,
        fe_working_city: res.working_city ? res.working_city : emptyDetails,
        FEVendorCode: res.vendor_code ? res.vendor_code : emptyDetails,
        vendorName: res.vendor_name ? res.vendor_name : emptyDetails,
        baseLocation: res.base_latitude && res.base_longitude
            ? "".concat(res.base_latitude, " ,").concat(res.base_longitude)
            : emptyDetails,
        base_location_address: res.base_location_address
            ? res.base_location_address
            : emptyDetails,
        fe_route_assignment_type: res.fe_route_assignment_type
            ? res.fe_route_assignment_type
            : emptyDetails,
        supervisor: res.supervisor != null && res.supervisor != undefined
            ? Boolean(res.supervisor)
            : false,
        backup: res.backup != null && res.backup != undefined ? Boolean(res.backup) : false,
        vendorCode: res.vendor_code ? res.vendor_code : emptyDetails,
        canUpdateCCCoordinates: res.can_update_cc_coordinates != null &&
            res.can_update_cc_coordinates != undefined
            ? Boolean(res.can_update_cc_coordinates)
            : false,
        canRaiseOnDemand: res.can_raise_ondemand != null &&
            res.can_raise_ondemand != undefined
            ? Boolean(res.can_raise_ondemand)
            : false,
        logistics_company: res.logistics_company != null &&
            res.logistics_company != undefined
            ? res.logistics_company
            : emptyDetails,
    };
    var billingDetails = {
        billing_module: res.billing_module ? res.billing_module : '',
        billing_cost: res.billing_cost ? String(res.billing_cost).split('.')[0] : '',
        billing_type: res.billing_type ? res.billing_type : ''
    };
    convertedRes['perviousDetials'] = {
        personal_details: personal_details,
        contact_details: contactDetails,
        bank_details: bank_details,
        drivingLiecenceDetails: driving_licence_details,
        employment_details: employmentDetails,
        billing_details: billingDetails,
        approval_status: res.approval_status ? res.approval_status : null,
        onboard_status: res.onboard_status ? res.onboard_status : null,
        fe_id: res.fe_id ? res.fe_id : emptyDetails,
    };
    if (res.updated_profile) {
        var updated_Employment_Details = {
            employee_vendor_id: res.updated_profile.employee_id === null
                ? emptyDetails
                : res.updated_profile.employee_id
                    ? res.updated_profile.employee_id
                    : '',
            fe_Type: res.updated_profile.fe_type ? res.updated_profile.fe_type : '',
            dateOfJoining: res.updated_profile.date_of_joining
                ? (0, array_helpers_1.normaldateFormatte)(res.updated_profile.date_of_joining)
                : '',
            company: res.updated_profile.company ? res.updated_profile.company : '',
            tenure: res.updated_profile.tenure ? res.updated_profile.tenure : '',
            labCode: res.updated_profile.lab_id ? res.updated_profile.lab_id : '',
            labName: res.updated_profile.center_name
                ? res.updated_profile.center_name
                : '',
            HudId: res.updated_profile.hub_name ? res.updated_profile.hub_name : '',
            regional_manager: (updatedRegionalManager === null || updatedRegionalManager === void 0 ? void 0 : updatedRegionalManager.label) ? updatedRegionalManager === null || updatedRegionalManager === void 0 ? void 0 : updatedRegionalManager.label : '',
            zonal_manager: (updatedZonalManager === null || updatedZonalManager === void 0 ? void 0 : updatedZonalManager.zonal_manager) ? updatedZonalManager === null || updatedZonalManager === void 0 ? void 0 : updatedZonalManager.zonal_manager : '',
            zone: (updatedZone === null || updatedZone === void 0 ? void 0 : updatedZone.zone) ? updatedZone === null || updatedZone === void 0 ? void 0 : updatedZone.zone : '',
            labState: res.updated_profile.center_state
                ? res.updated_profile.center_state
                : '',
            labCity: res.updated_profile.center_city
                ? res.updated_profile.center_city
                : '',
            fe_working_state: res.updated_profile.working_state
                ? res.updated_profile.working_state
                : '',
            fe_working_city: res.updated_profile.working_city
                ? res.updated_profile.working_city
                : '',
            FEVendorCode: res.updated_profile.vendor_code
                ? res.updated_profile.vendor_code
                : '',
            vendorName: res.updated_profile.vendor_name
                ? res.updated_profile.vendor_name
                : '',
            baseLocation: res.updated_profile.base_latitude && res.updated_profile.base_longitude
                ? "".concat(res.updated_profile.base_latitude, " ,").concat(res.updated_profile.base_longitude)
                : '',
            base_location_address: res.updated_profile.base_location_address
                ? res.updated_profile.base_location_address
                : '',
            fe_route_assignment_type: res.updated_profile.fe_route_assignment_type
                ? res.updated_profile.fe_route_assignment_type
                : '',
            supervisor: res.updated_profile.supervisor != null &&
                res.updated_profile.supervisor != undefined
                ? Boolean(res.updated_profile.supervisor)
                : Boolean(res.supervisor),
            backup: res.updated_profile.backup != null &&
                res.updated_profile.backup != undefined
                ? Boolean(res.updated_profile.backup)
                : Boolean(res.backup),
            vendorCode: res.updated_profile.vendor_code
                ? res.updated_profile.vendor_code
                : '',
            canUpdateCCCoordinates: res.updated_profile.can_update_cc_coordinates != null &&
                res.updated_profile.can_update_cc_coordinates != undefined
                ? Boolean(res.updated_profile.can_update_cc_coordinates)
                : Boolean(res.can_update_cc_coordinates),
            canRaiseOnDemand: res.updated_profile.can_raise_ondemand != null &&
                res.updated_profile.can_raise_ondemand != undefined
                ? Boolean(res.updated_profile.can_raise_ondemand)
                : Boolean(res.can_raise_ondemand),
            logistics_company: res.updated_profile.logistics_company != null &&
                res.updated_profile.logistics_company != undefined
                ? res.updated_profile.logistics_company
                : '',
        };
        var updated_Driving_Licence_Details = {
            vehicleType: res.updated_profile.vehicle_type
                ? res.updated_profile.vehicle_type
                : '',
            drivingLicence: res.updated_profile.driving_licence
                ? res.updated_profile.driving_licence
                : '',
            drivingLicenceExpirydate: res.updated_profile.driving_licence_expiry
                ? (0, array_helpers_1.normaldateFormatte)(res.updated_profile.driving_licence_expiry)
                : '',
            insuranceExpirydate: res.updated_profile.insurance_expiry
                ? (0, array_helpers_1.normaldateFormatte)(res.updated_profile.insurance_expiry)
                : '',
            insuranceNumber: res.updated_profile.insurance
                ? res.updated_profile.insurance
                : '',
            uploadInsuranceDoc: res.updated_profile.insurance_photo
                ? res.updated_profile.insurance_photo
                : '',
            proofOfDrivingLicence: res.updated_profile.driving_licence_doc
                ? res.updated_profile.driving_licence_doc
                : '',
            rcNumber: res.updated_profile.rc_number
                ? res.updated_profile.rc_number
                : '',
            rcExpirydate: res.updated_profile.rc_expiry
                ? res.updated_profile.rc_expiry
                : '',
            pucNumber: res.updated_profile.puc_number
                ? res.updated_profile.puc_number
                : '',
            pucExpirydate: res.updated_profile.puc_expiry
                ? res.updated_profile.puc_expiry
                : '',
            proofOfRegistrationCertificate: res.updated_profile.driving_licence_doc
                ? res.updated_profile.rc_document
                : '',
            proofOfPUCCertificate: res.updated_profile.driving_licence_doc
                ? res.updated_profile.puc_document
                : '',
        };
        var updated_Bank_Details = {
            AccountNumber: res.updated_profile.bank_account
                ? res.updated_profile.bank_account.toString()
                : '',
            Bank_Branch: res.updated_profile.bank_branch
                ? res.updated_profile.bank_branch.toString()
                : '',
            Bank_Name: res.updated_profile.bank_name
                ? res.updated_profile.bank_name.toString()
                : '',
            IFSC_Code: res.updated_profile.bank_ifsc
                ? res.updated_profile.bank_ifsc.toString()
                : '',
            UPI_ID: res.updated_profile.bank_upi_id
                ? res.updated_profile.bank_upi_id
                : '',
            proofOfBankAccountDetails: res.updated_profile.bank_cheque_doc
                ? res.updated_profile.bank_cheque_doc
                : '',
        };
        var currentDetailsObj = lodash_1.default.find(res.updated_profile.addresses, { type: 'present' });
        var permenentAddressDetails = lodash_1.default.find(res.updated_profile.addresses, { type: 'permanent' });
        var updated_Contact_Details = {
            addresslane1: currentDetailsObj ? currentDetailsObj.lane1 : '',
            addresslane2: currentDetailsObj ? currentDetailsObj.lane2 : '',
            landmark: currentDetailsObj ? currentDetailsObj.landmark : '',
            state: currentDetailsObj ? currentDetailsObj.state_name : '',
            city: currentDetailsObj ? currentDetailsObj.city_name : '',
            country: currentDetailsObj ? currentDetailsObj.country_name : '',
            pincode: currentDetailsObj ? (_f = currentDetailsObj.pincode) === null || _f === void 0 ? void 0 : _f.toString() : '',
            addressProofType: currentDetailsObj
                ? currentDetailsObj.proof_of_doc_type
                : '',
            proofOfAddress: currentDetailsObj ? currentDetailsObj.proof_of_doc : '',
            permenentAddresslane1: permenentAddressDetails
                ? permenentAddressDetails.lane1
                : '',
            permenentAddresslane2: permenentAddressDetails
                ? permenentAddressDetails.lane2
                : '',
            permenentLandmark: permenentAddressDetails
                ? permenentAddressDetails.landmark
                : '',
            permenentState: permenentAddressDetails
                ? permenentAddressDetails.state_name
                : '',
            permenentCity: permenentAddressDetails
                ? permenentAddressDetails.city_name
                : '',
            permenentCountry: permenentAddressDetails
                ? permenentAddressDetails.country_name
                : '',
            permenentPincode: permenentAddressDetails
                ? (_g = permenentAddressDetails.pincode) === null || _g === void 0 ? void 0 : _g.toString()
                : '',
            permanentProofOfAddressType: permenentAddressDetails
                ? permenentAddressDetails.proof_of_doc_type
                : '',
            permenentProofOfAddress: permenentAddressDetails
                ? permenentAddressDetails.proof_of_doc
                : '',
        };
        var updated_Profile_Details = {
            firstName: res.updated_profile.first_name
                ? res.updated_profile.first_name
                : '',
            lastName: res.updated_profile.last_name ? res.updated_profile.last_name : '',
            dob: res.updated_profile.dob
                ? (0, array_helpers_1.normaldateFormatte)(res.updated_profile.dob)
                : '',
            mobileNumber: res.updated_profile.mobile ? res.updated_profile.mobile : '',
            email: res.updated_profile.email ? res.updated_profile.email : '',
            gender: res.updated_profile.gender ? res.updated_profile.gender : '',
            emergencyContactNo: res.updated_profile.emergency_mobile
                ? res.updated_profile.emergency_mobile
                : '',
            uploadPhoto: res.updated_profile.avatar ? res.updated_profile.avatar : '',
            referenceContactName1: res.updated_profile.reference_name1
                ? res.updated_profile.reference_name1
                : '',
            referenceMobileNumber1: res.updated_profile.reference_mobile1
                ? res.updated_profile.reference_mobile1
                : '',
            referenceContactName2: res.updated_profile.reference_name2
                ? res.updated_profile.reference_name2
                : '',
            referenceMobileNumber2: res.updated_profile.reference_mobile2
                ? res.updated_profile.reference_mobile2
                : '',
        };
        var updated_Billing_Details = {
            billing_type: updatedBillingType ? updatedBillingType.label : '',
            billing_cost: res.updated_profile.billing_cost ? String(res.updated_profile.billing_cost).split('.')[0] : '',
            billing_module: updatedBillingModule ? updatedBillingModule.label : '',
        };
        convertedRes['updatedDetials'] = {
            personal_details: updated_Profile_Details,
            contact_details: updated_Contact_Details,
            bank_details: updated_Bank_Details,
            drivingLiecenceDetails: updated_Driving_Licence_Details,
            employment_details: updated_Employment_Details,
            billing_details: updated_Billing_Details,
            approval_status: res.updated_profile.approval_status
                ? res.updated_profile.approval_status
                : null,
            onboard_status: res.updated_profile.onboard_status
                ? res.updated_profile.onboard_status
                : null,
            fe_id: res.updated_profile.fe_id ? res.updated_profile.fe_id : '',
        };
    }
    return convertedRes;
};
exports.convertApprovalDetailsFromRes = convertApprovalDetailsFromRes;
var cashDeletionApprovalList = function (payLoad) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .get({
            endPoint: api_service_1.api_service.api_urls.CASH_APPROVAL_LIST + "?".concat(payLoad),
            domain: process.env.APPROVAL_BASEURL,
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data.data);
            }
            var erroMessage = response.data
                ? response.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.cashDeletionApprovalList = cashDeletionApprovalList;
var convertCashDeletionApprovalList = function (response) {
    var convertedResponse = [];
    for (var _i = 0, _a = response && response; _i < _a.length; _i++) {
        var data = _a[_i];
        convertedResponse.push({
            amount: data.data.amount,
            cash_collected_date_time: data.data.cash_collected_date_time,
            cc_handshake_date_time: data.data.cc_handshake_date_time,
            center_name: data.data.center_name,
            city: data.data.city,
            current_owner_id: data.data.current_owner_id,
            current_owner_type: data.data.current_owner_type,
            fe_code: data.data.fe_code,
            fe_mobile: data.data.fe_mobile,
            fe_name: data.data.fe_name,
            fe_zone: data.data.fe_zone,
            id: data._id,
            cash_id: data.data.id,
            invoice_code: data.data.invoice_code,
            is_deleted: data.data.is_deleted,
            lab_code: data.data.lab_code,
            lab_name: data.data.lab_name,
            state: data.data.state,
            warehouse_code: data.data.warehouse_code,
            status: data.status,
            type: data.type,
            updated_date_time: data.updated_date_time
        });
    }
    return convertedResponse;
};
exports.convertCashDeletionApprovalList = convertCashDeletionApprovalList;
var cashActionUpdate = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .put({
            endPoint: api_service_1.api_service.api_urls.CASH_DELETION_UPDATE,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                resolve(res.data);
                react_hot_toast_1.default.success(res.data.message);
            }
            else {
                react_hot_toast_1.default.error(res.data.message);
            }
        })
            .catch(function (e) {
            react_hot_toast_1.default.success(e.message);
        });
    });
};
exports.cashActionUpdate = cashActionUpdate;
exports.approvalsFormConstants = {
    personal_details: {
        firstName: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.firstname,
            editable: true,
            type: 'string',
        },
        lastName: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.lastname,
            editable: false,
            type: 'string',
        },
        dob: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.dob,
            editable: true,
            type: 'date',
        },
        mobileNumber: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.mobilenumber,
            editable: false,
            type: 'number',
        },
        email: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.email,
            editable: false,
            type: 'string',
        },
        emergencyContactNo: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.emeregencyContact,
            editable: false,
            type: 'number',
        },
        gender: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.gender,
            editable: false,
            type: 'string',
        }
    },
    reference_numbers: {
        referenceContactName1: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.referenceName1,
            editable: false,
            type: 'string',
        },
        referenceMobileNumber1: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.referenceMobileno1,
            editable: false,
            type: 'number',
        },
        referenceContactName2: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.referenceName2,
            editable: false,
            type: 'string',
        },
        referenceMobileNumber2: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.referenceMobileno2,
            editable: false,
            type: 'number',
        },
    },
    present_address_details: {
        addresslane1: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.line1,
            editable: false,
            type: 'string',
        },
        addresslane2: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.line2,
            editable: false,
            type: 'string',
        },
        landmark: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.landmark,
            editable: false,
            type: 'string',
        },
        state: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.state,
            editable: false,
            type: 'string',
        },
        city: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.city,
            editable: false,
            type: 'string',
        },
        country: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.country,
            editable: false,
            type: 'string',
        },
        pincode: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.pincode,
            editable: false,
            type: 'pincode',
        },
        addressProofType: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.addressProofType,
            editable: false,
            type: 'string',
        },
    },
    permanent_address_details: {
        permenentAddresslane1: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.line1,
            editable: false,
            type: 'string',
        },
        permenentAddresslane2: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.line2,
            editable: false,
            type: 'string',
        },
        permenentLandmark: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.landmark,
            editable: false,
            type: 'string',
        },
        permenentCity: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.city,
            editable: false,
            type: 'string',
        },
        permenentState: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.state,
            editable: false,
            type: 'string',
        },
        permenentCountry: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.country,
            editable: false,
            type: 'string',
        },
        permenentPincode: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.pincode,
            editable: false,
            type: 'string',
        },
        addressProofType: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.addressProofType,
            editable: false,
            type: 'string',
        },
    },
    bank_details: {
        AccountNumber: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.accountNo,
            editable: false,
            type: 'account_number',
        },
        IFSC_Code: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.ifscCode,
            editable: false,
            type: 'ifsc',
        },
        Bank_Name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.bankName,
            editable: false,
            type: 'string',
        },
        Bank_Branch: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.bankBranch,
            editable: false,
            type: 'string',
        },
        UPI_ID: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.upi,
            editable: false,
            type: 'upi',
        }
    },
    vehicle_etails: {
        vehicleType: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.vehicleType,
            editable: false,
            type: 'string',
        },
        drivingLicence: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.drivingLicence,
            editable: false,
            type: 'number',
        },
        drivingLicenceExpirydate: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.drivingLicenceExDate,
            editable: false,
            type: 'date',
        },
        insuranceNumber: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.insurencNo,
            editable: false,
            type: 'number',
        },
        insuranceExpirydate: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.insurencExDate,
            editable: false,
            type: 'date',
        },
        rcNumber: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.rcNumber,
            editable: false,
            type: 'number',
        },
        rcExpirydate: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.rcExpiry,
            editable: false,
            type: 'date',
        },
        puc_number: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.puc_number,
            editable: false,
            type: 'number',
        },
        pucExpirydate: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.pucExpiry,
            editable: false,
            type: 'date',
        },
    },
    employment_details: {
        employee_vendor_id: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.employee_vendor_id,
            editable: false,
            type: 'string',
        },
        fe_Type: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.feType,
            editable: false,
            type: 'string',
        },
        dateOfJoining: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.doj,
            editable: true,
            type: 'date',
        },
        company: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.company,
            editable: false,
            type: 'string',
        },
        tenure: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.tenure,
            editable: false,
            type: 'string',
        },
        labCode: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.labCode,
            editable: false,
            type: 'string',
        },
        labName: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.labName,
            editable: false,
            type: 'string',
        },
        HudId: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.hub,
            editable: false,
            type: 'string',
        },
        regional_manager: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.regionalManager,
            editable: false,
            type: 'regional_manager',
        },
        zonal_manager: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.zone,
            editable: false,
            type: 'zonal_manager',
        },
        zone: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.zonalManager,
            editable: false,
            type: 'zonal_manager',
        },
        labState: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.labState,
            editable: false,
            type: 'string',
        },
        labCity: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.labCity,
            editable: false,
            type: 'string',
        },
        fe_working_state: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.feWorkingState,
            editable: false,
            type: 'string',
        },
        fe_working_city: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.feWorkingCity,
            editable: false,
            type: 'string',
        },
        vendorName: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.vendorName,
            editable: false,
            type: 'string',
        },
        vendorCode: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.vendorCode,
            editable: false,
            type: 'string',
        },
        fe_id: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.feWorkingCode,
            editable: false,
            type: 'string',
        },
        base_location_address: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.baseLocationAddress,
            editable: false,
            type: 'string',
        },
        baseLocation: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.baseLocationCoordinates,
            editable: false,
            type: 'string',
        },
        fe_route_assignment_type: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.assignRouteType,
            editable: false,
            type: 'string',
        },
        canRaiseOnDemand: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.canRaiseOndemand,
            editable: false,
            type: 'string',
        },
        canUpdateCCCoordinates: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.canUpdateCC,
            editable: false,
            type: 'string',
        },
        backup: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.backup,
            editable: false,
            type: 'string',
        },
        supervisor: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.supervisor,
            editable: false,
            type: 'string',
        },
        additionalRole: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.additionalRole,
            editable: false,
            type: 'role',
        },
    },
    billing_details: {
        billing_module: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.billingModule,
            editable: true,
            type: 'dropdown',
        },
        billing_type: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.billingType,
            editable: false,
            type: 'string',
        },
        billing_cost: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.billingCost,
            editable: true,
            type: 'string',
        },
    }
};
exports.feDetailLabels = {
    personal_details: {
        first_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.firstname,
            editable: true,
            type: 'string',
        },
        last_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.lastname,
            editable: false,
            type: 'string',
        },
        dob: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.dob,
            editable: false,
            type: 'date',
        },
        mobile: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.mobilenumber,
            editable: false,
            type: 'number',
        },
        email: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.email,
            editable: false,
            type: 'string',
        },
        emergency_mobile: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.emeregencyContact,
            editable: false,
            type: 'number',
        },
        gender: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.gender,
            editable: false,
            type: 'string',
        },
        fe_id: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.feId,
            editable: false,
            type: 'string',
        },
        avatar: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.avatar,
            editable: false,
            type: 'document',
        },
    },
    reference_name1: {
        label: profile_detaile_lable_1.default.PROFILE_LABLES.referenceName1,
        editable: false,
        type: 'string',
    },
    reference_mobile1: {
        label: profile_detaile_lable_1.default.PROFILE_LABLES.referenceMobileno1,
        editable: false,
        type: 'number',
    },
    reference_name2: {
        label: profile_detaile_lable_1.default.PROFILE_LABLES.referenceName2,
        editable: false,
        type: 'string',
    },
    reference_mobile2: {
        label: profile_detaile_lable_1.default.PROFILE_LABLES.referenceMobileno2,
        editable: false,
        type: 'number',
    },
    present_address_details: {
        lane1: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.line1,
            editable: false,
            type: 'string',
        },
        lane2: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.line2,
            editable: false,
            type: 'string',
        },
        landmark: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.city,
            editable: false,
            type: 'string',
        },
        state_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.landmark,
            editable: false,
            type: 'string',
        },
        city_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.landmark,
            editable: false,
            type: 'string',
        },
        country_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.country,
            editable: false,
            type: 'string',
        },
        pincode: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.pincode,
            editable: false,
            type: 'pincode',
        },
        proof_of_doc_type: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.addressProofType,
            editable: false,
            type: 'string',
        },
        proof_of_doc: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.addressProof,
            editable: false,
            type: 'string',
        },
    },
    permanent_address_details: {
        lane1: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.line1,
            editable: false,
            type: 'string',
        },
        lane2: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.line2,
            editable: false,
            type: 'string',
        },
        landmark: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.city,
            editable: false,
            type: 'string',
        },
        state_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.landmark,
            editable: false,
            type: 'string',
        },
        city_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.landmark,
            editable: false,
            type: 'string',
        },
        country_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.country,
            editable: false,
            type: 'string',
        },
        pincode: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.pincode,
            editable: false,
            type: 'pincode',
        },
        proof_of_doc_type: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.addressProofType,
            editable: false,
            type: 'string',
        },
        proof_of_doc: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.addressProof,
            editable: false,
            type: 'string',
        },
    },
    bank_details: {
        bank_account: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.accountNo,
            editable: false,
            type: 'account_number',
        },
        bank_ifsc: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.ifscCode,
            editable: false,
            type: 'ifsc',
        },
        bank_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.bankName,
            editable: false,
            type: 'string',
        },
        bank_branch: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.bankBranch,
            editable: false,
            type: 'string',
        },
        bank_upi_id: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.upi,
            editable: false,
            type: 'upi',
        },
        bank_cheque_doc: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.bankProof,
            editable: false,
            type: 'document',
        },
    },
    vehicle_details: {
        vehicle_type: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.vehicleType,
            editable: false,
            type: 'string',
        },
        driving_licence: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.drivingLicence,
            editable: false,
            type: 'number',
        },
        driving_licence_expiry: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.drivingLicenceExDate,
            editable: false,
            type: 'date',
        },
        driving_licence_doc: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.drivingDoc,
            editable: false,
            type: 'document',
        },
        insurance: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.insurencNo,
            editable: false,
            type: 'number',
        },
        insurance_expiry: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.insurencExDate,
            editable: false,
            type: 'date',
        },
        insurance_photo: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.uploadInsurence,
            editable: false,
            type: 'document',
        },
        rc_number: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.rcNumber,
            editable: false,
            type: 'number',
        },
        rc_expiry: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.rcExpiry,
            editable: false,
            type: 'date',
        },
        rc_document: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.rcDoc,
            editable: false,
            type: 'document',
        },
        puc_number: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.puc_number,
            editable: false,
            type: 'number',
        },
        puc_expiry: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.pucExpiry,
            editable: false,
            type: 'date',
        },
        puc_document: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.pucDoc,
            editable: false,
            type: 'document',
        },
    },
    employment_details: {
        fe_Type: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.feType,
            editable: false,
            type: 'string',
        },
        date_of_joining: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.doj,
            editable: false,
            type: 'string',
        },
        company: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.companyOne,
            editable: false,
            type: 'string',
        },
        logistics_company: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.companyTwo,
            editable: false,
            type: 'string',
        },
        tenure: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.tenure,
            editable: false,
            type: 'string',
        },
        lab_code: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.labCode,
            editable: false,
            type: 'string',
        },
        labName: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.labName,
            editable: false,
            type: 'string',
        },
        hub_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.hub,
            editable: false,
            type: 'string',
        },
        regional_manager_id: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.regionalManager,
            editable: false,
            type: 'regional_manager',
        },
        zone_id: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.zone,
            editable: false,
            type: 'zonal_manager',
        },
        centre_state: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.labState,
            editable: false,
            type: 'string',
        },
        centre_city: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.labCity,
            editable: false,
            type: 'string',
        },
        working_state: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.feWorkingState,
            editable: false,
            type: 'string',
        },
        working_city: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.feWorkingCity,
            editable: false,
            type: 'string',
        },
        vendor_code: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.vendorCode,
            editable: false,
            type: 'string',
        },
        vendor_name: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.vendorName,
            editable: false,
            type: 'string',
        },
        fe_id: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.feWorkingCode,
            editable: false,
            type: 'string',
        },
        employee_id: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.employee_vendor_id,
            editable: false,
            type: 'string',
        },
        base_location_address: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.baseLocationAddress,
            editable: false,
            type: 'string',
        },
        fe_route_assignment_type: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.assignRouteType,
            editable: false,
            type: 'string',
        },
        can_raise_ondemand: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.canRaiseOndemand,
            editable: false,
            type: 'string',
        },
        can_update_cc_coordinates: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.canUpdateCC,
            editable: false,
            type: 'string',
        },
        backup: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.backup,
            editable: false,
            type: 'string',
        },
        supervisor: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.supervisor,
            editable: false,
            type: 'string',
        },
    },
    billing_details: {
        billing_module: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.billingModule,
            editable: false,
            type: 'string',
        },
        billing_type: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.billingType,
            editable: false,
            type: 'string',
        },
        billing_cost: {
            label: profile_detaile_lable_1.default.PROFILE_LABLES.billingCost,
            editable: false,
            type: 'number',
        },
    },
};
var updateFeDetails = function (payload, id) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.ACTIVEFE_EDIT,
            payLoad: id != null && id != undefined
                ? __assign(__assign({}, payload), { user_id: Number(id) }) : payload,
            domain: process.env.VENDOR_BASE_URL,
        })
            .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (res.data.statusCode === 200) {
                    resolve(res);
                    react_hot_toast_1.default.success('Details are successfully updated');
                }
                else {
                    react_hot_toast_1.default.error(res.data.message);
                }
                return [2];
            });
        }); })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.data.errors);
        });
    });
};
exports.updateFeDetails = updateFeDetails;
